<template>
  <div>
    <transition name="slide-fade-down">
      <b-img
        :src="require('@/assets/images/logo_centered.svg')"
        width="300"
        class="rounded-0"
        v-show="show"
      />
    </transition>

    <div class="mt-5">
      <h4 class="font-weight-bold">Send Reset Code</h4>
      <p class="mt-3">
        You will receive an email with instructions to reset your
        <br />password.
      </p>
    </div>

    <b-form class="mt-4" @submit.prevent="onSubmit">
      <b-form-group id="input-group-1" class="col-12">
        <i class="clearable" v-show="form.email" @click="form.email = ''"
          >&times;</i
        >
        <b-form-input
          id="input-1"
          v-model="form.email"
          class="input-effect"
          :class="form.email ? 'has-content' : ''"
          type="email"
          required
          autofocus
        ></b-form-input>
        <label>Email address</label>
        <div class="input-error" v-if="form.$getError('email')">
          {{ form.$getError('email')[0] }}
        </div>
      </b-form-group>

      <!-- API Error Message -->
      <div class="form-message mb-4" v-show="form.$errorMessage">
        {{ form.$errorMessage }}
      </div>

      <b-button class="mt-4" type="submit" variant="primary" block>
        <b-spinner class="mr-2" small v-if="form.$busy"></b-spinner>Reset
        Password
      </b-button>

      <div class="d-flex justify-content-between mt-4">
        <div>
          <b-link class="form-link" :to="{ name: 'auth.login-page' }"
            >Login</b-link
          >
        </div>
        <div>
          Don’t have an account?
          <b-link class="form-link" :to="{ name: 'auth.register-page' }"
            >Create one</b-link
          >
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import Form from '@/utils/form'

export default {
  data() {
    return {
      show: false,
      form: new Form({
        email: ''
      })
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/forgot-password', {
          email: this.form.email
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$router.replace({
            name: 'auth.reset-password-page',
            params: {
              email: this.form.$data().email
            }
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  mounted() {
    this.show = true
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-link {
  font-weight: bold;
}
</style>
